// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import MintUI from 'mint-ui'
import 'mint-ui/lib/style.css'
import App from './App'
import router from './router'
import promise from 'es6-promise'
import filters from './filters'
import './assets/css/reset.css'
import 'lib-flexible/flexible.js'
Vue.use(MintUI)

import VueAwesomeSwiper from 'vue-awesome-swiper'
import 'swiper/dist/css/swiper.css'
Vue.use(VueAwesomeSwiper)

promise.polyfill()
Vue.config.productionTip = false

// 防抖 防连点
Vue.directive('throttle', { 
  inserted(el, binding) { 
    el.addEventListener('click', () => { 
      el.style.pointerEvents = 'none'; 
      if (!el.disabled) { 
        setTimeout(() => { 
          el.style.pointerEvents = 'auto'; 
        }, binding.value || 2000); 
      } 
    }); 
  } 
})

var crypto = require('crypto')
function sha1Sign(str) {
  var sha1 = crypto.createHash("sha1");//定义加密方式
  sha1.update(str);
  return sha1.digest("hex");
}
function md5Sign(str) {
  var md5 = crypto.createHash("md5");
  md5.update(str);
  return md5.digest('hex');
}

let appId = "0yfoZsFJJk7PeFwZ";
let appKey = "AiPCKjWxSYCVJw9WS3kOqVuC8gZ7LFBq";
let timeStamp = Math.round(new Date().getTime()/1000)
var sha1 = sha1Sign(timeStamp+appKey+timeStamp);

window.appId = '0yfoZsFJJk7PeFwZ'
window.timeStamp = timeStamp
window.sign = md5Sign(sha1+appId)


Object.keys(filters).forEach((key) => {
  Vue.filter(key, filters[key])
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js